import React from "react";
import { Table, Typography } from "antd";
import { useIntl } from "react-intl";
import moment from "moment";

const { Text } = Typography;
const VersionsTable = (props) => {
  const { onVersionChange, selectedVersion, sortedData } = props;
  const intl = useIntl();

  const columns = [
    {
      title: intl.formatMessage({
        id: "app.tariffs.base_rate",
      }),
      dataIndex: "base_rate",
      render: (text) => <Text>{text}</Text>,
    },
    {
      title: intl.formatMessage({
        id: "app.tariffs.effective_from",
      }),
      dataIndex: "effective_from",
      render: (text, record, index) => (
        <Text>
          {record.initial
            ? intl.formatMessage({
                id: "app.tariffs.initial",
              })
            : moment(text).format("MM/YYYY")}
        </Text>
      ),
    },
  ];

  const rowSelection = {
    selectedRowKeys: selectedVersion ? [selectedVersion.id] : [],
    onChange: (selectedRowKeys, selectedRows) => {
      onVersionChange(selectedRows[0]);
    },
    getCheckboxProps: (record) => ({
      name: record.name,
    }),
  };
  return (
    <div style={{ width: "100%" }}>
      <Table
        bordered
        rowKey={(record) => record.id}
        rowSelection={{
          type: "radio",
          ...rowSelection,
        }}
        columns={columns}
        dataSource={sortedData}
        pagination={false}
      />
    </div>
  );
};
export default VersionsTable;
